import classnames from 'classnames';
import { numberFormat } from 'lib/utils';
import React from 'react';
import styles from './styles.scss';

interface Props {
  monthlyLivingCost: number;
  className?: string;
}

const CostBar = ({ monthlyLivingCost, className }: Props): JSX.Element => {
  return (
    <>
      <section className={classnames(styles.costBar, className && className)}>
        <span className={styles.text}>Estimat faste bokostnader per måned:</span>
        <span className={styles.number}>{numberFormat.format(monthlyLivingCost)},-</span>
      </section>
      {/*
      <div className={styles.spacer} />
      */}
    </>
  );
};

export default CostBar;
